import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";
import { addNoteFromAI } from "./editor";
import { FailureSnackbar, SuccessSnackbar } from "./snackbar";

interface IPresenter {
  sizing?: { width: number; height: number };
  zoomSizing?: { width: number; height: number };
  recording: boolean;
  searching: boolean;
  sendNote: boolean;
  notePrompt: {
    active: boolean;
    data: string;
    message:string;
  };
  activeMachineshot: boolean;
  showRecordingStarted: boolean;
  showRecordingStopped: boolean;
  isPipMouseOver: boolean;
  showVideo: boolean;
  recordingAlert: boolean;
  recordingStatusMessage: string;
  isVdiSharingOn: boolean;
}

const initialState: IPresenter = {
  sizing: { width: 600, height: 400 },
  zoomSizing: { width: 600, height: 400 },
  recording: false,
  searching: false,
  sendNote: false,
  notePrompt: {
    active: false,
    data: "",
    message:""
  },
  activeMachineshot: false,
  showRecordingStarted: false,
  showRecordingStopped: false,
  isPipMouseOver: false,
  showVideo: false,
  recordingAlert: false,
  recordingStatusMessage: "",
  isVdiSharingOn: false,
};

const slice = createSlice({
  name: "presenter",
  initialState,
  reducers: {
    getSizing(state, action) {
      state.sizing = action.payload;
    },
    getZoomSizing(state, action) {
      state.zoomSizing = action.payload;
    },
    recordingState(state, action) {
      state.recording = action.payload;
    },
    showRecordingStartedDialog(state, action) {
      state.showRecordingStarted = action.payload;
    },
    showRecordingStoppedDialog(state, action) {
      state.showRecordingStopped = action.payload;
    },
    searching(state, action) {
      state.searching = action.payload;
    },
    sendingNote(state, action) {
      state.sendNote = action.payload;
    },
    sendPrompt(state, action) {
      state.notePrompt = action.payload;
    },
    activeMachineScreenshot(state, action) {
      state.activeMachineshot = action.payload;
    },
    handlePIPMouseover(state, action) {
      state.isPipMouseOver = action.payload;
    },
    handleShowVideo(state, action) {
      state.showVideo = action.payload;
    },
    handleRecordingAlert(state, action) {
      state.recordingAlert = action.payload;
    },
    setRecordingStatus(state, action) {
      state.recordingStatusMessage = action.payload;
    },
    setIsVdiSharingOn(state, action) {
      state.isVdiSharingOn = action.payload;
    }
  },
});

export const reducer = slice.reducer;

export const presenterActions = slice.actions;

const BASE_URL = process.env.REACT_APP_API_URL;

export const storeSizing = (data) => async (dispatch) => {
  dispatch(slice.actions.getSizing(data));
};

export const storeZoomSizing = (data) => async (dispatch) => {
  dispatch(slice.actions.getZoomSizing(data));
};

export const recordingStatus = (data) => async (dispatch) => {
  dispatch(slice.actions.recordingState(data));
};

export const showRecordingStartedDialog = (data) => async (dispatch) => {
  dispatch(slice.actions.showRecordingStartedDialog(data));
};

export const showRecordinStoppedDialog = (data) => async (dispatch) => {
  dispatch(slice.actions.showRecordingStoppedDialog(data));
};

export const setRecordingStatus = (data) => async (dispatch) => {
  dispatch(slice.actions.setRecordingStatus(data));
};

export const fetchTheQueryAns = (data) => async (dispatch) => {
  dispatch(slice.actions.searching(true));
  try {
    const response = await axios.patch(
      `${BASE_URL}/events/api/v1/events/note-query`,
      data
    );
    if (response?.data?.status) {
      dispatch(addNoteFromAI(window.btoa(response?.data?.data[0]?.message?.content)));
    } else if (!response?.data?.status) {
      dispatch(FailureSnackbar({
        message: `${response?.data?.message}`,
        open: true,
      }));
    }
  } catch (error) {
    throw new Error("Failed to fetch the data");
  } finally {
    dispatch(slice.actions.searching(false));
  }
};

export const sendContentToParticipant = (data) => async (dispatch) => {
  try {
    dispatch(slice.actions.sendingNote(true));
    const response = await axios.post(`${BASE_URL}/events/api/v1/events/send-note`, {
      text: data,
    });
    if (response?.data?.status) {
      setTimeout(() => {
        dispatch(slice.actions.sendingNote(false));
      }, 1000);
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const screenshotActiveMachine = (data) => async (dispatch) => {
  dispatch(slice.actions.activeMachineScreenshot(data));
};

export const notePromptSend = (value, data, message) => async (dispatch) => {
  dispatch(slice.actions.sendPrompt({ active: value, data: data, message: message }));
};

export const handlePIPMouseover = (data) => (dispatch) => {
  dispatch(slice.actions.handlePIPMouseover(data));
};

export const handleRecordingAlert = (data) => (dispatch) => {
  dispatch(slice.actions.handleRecordingAlert(data));
};

export const handleRecordingMsg = (data) => (dispatch) => {
  dispatch(
      SuccessSnackbar({
        message: `${data}`,
        open: true,
      })
    );
};

export const handleSendRecordingFailedMessage = (data) => (dispatch) => {
  dispatch(
    FailureSnackbar({
        message: `${data}`,
        open: true,
      })
    );
};

export default slice;
